import React, { useMemo, useState } from 'react'; // Added useState
import {
	Typography,
	FormGroup,
	FormControlLabel,
	FormLabel,
	TextField,
	Grid,
	FormControl,
} from '@mui/material';
import {
	ADDITIONAL_GOALS_OF_COVER,
	FULL_NEEDS_ANALYSIS,
	GOALS_OF_COVER,
	GOALS_OF_COVER_LABELS,
} from '@/components/forms/CreateNewBusinessForm/validationSchema';
import { useObjectContext } from '@/hooks/useObjectContext';
import { ClientCheckbox } from '@/components/buttons/ClientCheckbox';
import { useUpdateDealRowMutation } from '@/features/deals/dealsApi';
import FolioCheckbox from '@/components/FolioCheckbox';

export const GoalsOfCover = () => {
	const { dealRow } = useObjectContext();

	const goalsOfCover = useMemo(() => dealRow?.[GOALS_OF_COVER] ?? [], [dealRow]);
	const [additionalGoalsOfCover, setAdditionalGoalsOfCover] = useState(
		dealRow?.[ADDITIONAL_GOALS_OF_COVER] ?? '',
	);

	const [updateDeal, { isLoading }] = useUpdateDealRowMutation();

	const onChange = async (newValues) => {
		if (newValues !== goalsOfCover) {
			await updateDeal({
				dealId: dealRow?.dealId,
				docId: dealRow?.id,
				properties: {
					[GOALS_OF_COVER]: newValues,
				},
			}).unwrap();
		}
	};

	const handleTextBlur = async (event) => {
		const newValue = event.target.value.trim();
		if (newValue !== dealRow?.[ADDITIONAL_GOALS_OF_COVER]) {
			await updateDeal({
				dealId: dealRow?.dealId,
				docId: dealRow?.id,
				properties: {
					[ADDITIONAL_GOALS_OF_COVER]: newValue,
				},
			}).unwrap();
		}
	};

	const handleTextChange = (event) => {
		setAdditionalGoalsOfCover(event.target.value);
	};

	return (
		<FormGroup row sx={{ width: '100%' }}>
			<FormLabel>Goals of cover</FormLabel>
			<Grid container width={'100%'} rowSpacing={1} columnSpacing={2}>
				{Object.entries(GOALS_OF_COVER_LABELS).map(([value, label]) => (
					<Grid size={{ xs: 12, sm: 6 }} key={`client-goals-${value}`}>
						<FolioCheckbox
							checked={goalsOfCover.includes(value)}
							label={label}
							onChange={() => {
								let newValues;
								if (goalsOfCover.includes(value)) {
									newValues = goalsOfCover.filter((i) => i !== value);
								} else {
									if (value === FULL_NEEDS_ANALYSIS) {
										newValues = [FULL_NEEDS_ANALYSIS];
									} else if (goalsOfCover.includes(FULL_NEEDS_ANALYSIS)) {
										newValues = [];
									} else {
										newValues = [...goalsOfCover, value];
									}
								}
								onChange(newValues);
							}}
							disabled={isLoading}
						/>
					</Grid>
				))}
				<Grid size={12}>
					<FormControl fullWidth sx={{ pt: 1 }}>
						<FormLabel>{'Add additional goals of cover here'}</FormLabel>
						<TextField
							fullWidth
							value={additionalGoalsOfCover}
							onChange={handleTextChange}
							onBlur={handleTextBlur}
							multiline
							rows={4}
							disabled={isLoading}
						/>
					</FormControl>
				</Grid>
			</Grid>
		</FormGroup>
	);
};
